import { faPlus } from "@fortawesome/free-solid-svg-icons";
import Page, { PageActionsType } from "components/common/page/Page";
import AccommodationMaintenanceTypeDatalist from "components/entities/accommodation/work/maintenance/type/AccommodationMaintenanceTypeDatalist";
import { useRef, useState } from "react";
import useAppContext from "utilities/hooks/useAppContext";

const FORM_MODAL_ID = "AccommodationMaintenanceTypeDatalistPage-from";

const AccommodationMaintenanceTypeDatalistPage = () => {
    const datalistRef = useRef<{openForm: () => void}>(null);
    const pageActions: PageActionsType = [
        {
            icon: faPlus,
            name: 'add',
            title: 'button.add',
            link: () => {
                datalistRef.current?.openForm();
            }
        }
    ];

    return (
        <Page wFull title="pages.accommodation.work.maintenance-type.list" actions={pageActions}>
            <AccommodationMaintenanceTypeDatalist ref={datalistRef} name="AccommodationMaintenanceTypeDatalistPage" />
        </Page>
    );
};

export default AccommodationMaintenanceTypeDatalistPage;
